<template>
  <v-col
    cols="6"
    md="3"
  >
    <v-card
      class="rounded-lg pa-3 elevation-1"
      height="100%"
    >
      <div
        v-if="$store.state.showAllInfo"
        class="mb-1 caption"
      ></div>
      <div>
        <div
          @click="disabled ? void 0 : select()"
          class="cursor-pointer fill-height d-flex flex-column justify-space-between"
        >
          <v-row
            no-gutters
            align="start"
            justify="space-between"
            style="position: relative"
          >
            <div style="position: absolute">
              <v-icon
                :size="20"
                :color="isSelected ? 'primary' : 'grey'"
              >
                {{ ingredientIconName }}
              </v-icon>
            </div>
            <v-img
              v-if="withImage && image"
              height="40"
              width="40"
              :src="image"
              aspect-ratio="1"
              contain
            />
            <div
              v-else
              style="height: 40px"
            ></div>
          </v-row>
          <div class="d-flex align-center justify-center mt-2">
            <div class="text-body-2 noselect text-center">
              {{ ingredient.name }}
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
  export default {
    name: 'OneIngredientTile',

    props: {
      productIngredient: Object,
      productIngredientGroup: Object,
      selectedIngredient: Object, // объект { id, image, name } или null
      withImage: Boolean,
      disabled: Boolean
    },

    computed: {
      ingredient() {
        return this.productIngredient.ingredient
      },
      image() {
        return this.ingredient.image || '/media/not-found.png'
      },
      isSelected() {
        return this.selectedIngredient && this.selectedIngredient.id === this.ingredient.id
      },
      ingredientIconName() {
        return this.isSelected ? 'mdi-check-circle-outline' : 'mdi-checkbox-blank-circle-outline'
      }
    },

    methods: {
      select() {
        this.$emit('select', {
          id: this.ingredient.id,
          image: this.ingredient.image || '',
          name: this.ingredient.name || ''
        })
      }
    }
  }
</script>
